/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { connect } from 'react-redux';

import api from 'api';
import routeNames from 'lib/routeNames';

import userSelectors from 'redux/reduxStore/user';
import groupSelectors from 'redux/reduxStore/group';
import userActions from 'redux/actions/user';
import uiStateActions from 'redux/actions/uiState';
import navigationActions from 'redux/actions/navigation';

import ForgotPasswordView from './ForgotPassword.view';
import CheckYourInbox from 'components/pages/other/CheckYourInbox';
// import { goBackToAccount, submitEmailChange } from '../actions';
import AppUtils from 'lib/AppUtils';

function mapStateToProps(state) {
  const group = groupSelectors.getActiveGroup(state);
  return {
    userId: userSelectors.getLoggedInUser(state).id,
    groupId: group.id,
    organizationName: group.organization_name,
    email: userSelectors.getEmail(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    goBack: () => {
      dispatch(navigationActions.goBackTo(routeNames.home()));
    },
    submitEmail: (email,groupId) => {
      dispatch(userActions.updateEmail(email));
      return api.passwordApi.forgot(email, groupId, AppUtils.getGroupSubdomain());
    },
    showApiError: (apiError) => {
      return uiStateActions.showNotification(apiError.responseMessage());
    },
  }
}

class ForgotPassword extends React.Component {

  constructor(props) {
    super(props);

    this.submitEmail = this.submitEmail.bind(this);

    this.state = {
      emailSubmitted: false,
    };
  }

  submitEmail(email) {
    this.props.submitEmail(email, this.props.groupId)
    .then(() => { this.setState({ emailSubmitted: true }) })
    .catch(apiError => this.props.showApiError(apiError));
  }

  render() {
    if (this.state.emailSubmitted) {
      return (
        <CheckYourInbox
          goBack={() => { this.setState({ emailSubmitted: false }); }}
          titlePhrase={{ id: 'forgotPwdCheckInbox.title.text' }}
          notificationPhrase={{ id: 'forgotPwdCheckInbox.notification.message.text' }}
          email={this.props.email}
          organizationName={this.props.organizationName}
        />
      );
    }

    return (
      <ForgotPasswordView
        email={this.props.email}
        organizationName={this.props.organizationName}
        goBack={this.props.goBack}
        submitEmail={this.submitEmail}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);